import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { Field, reduxForm, reset } from 'redux-form';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
// Component
import AdminStarRating from '../AdminStarRating';
import Link from '../../Link';
// Redirection
import history from '../../../core/history';
// Translation
import { FormattedMessage, injectIntl } from 'react-intl';
import CommonFormComponent from '../../CommonField/CommonFormComponent';
// GraphQL
import WriteUserReviewMutation from './WriteUserReviewMutation.graphql';
import showToaster from '../../../helpers/toasterMessages/showToaster';
import validate from './validate';
import { withMutation } from '../../../hoc/withGraphql';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';
import { GoBackArrow } from '../../Common/Assets/SvgIconComponent/CommonSvgIcon';
import cp from '../../../components/commonStyle.css';
import s from './UserReviewsForm.css';
import messages from '../../../locale/jsonMessages';

class UserReviewsForm extends Component {

    static propTypes = {
        title: PropTypes.string.isRequired,
        initialValues: PropTypes.object,
    };

    constructor(props) {
        super(props);
        this.submitForm = this.submitForm.bind(this);
    }


    renderStarRating = ({ input, label, meta: { touched, error }, className, children }, value) => {
        const { formatMessage } = this.props.intl;
        return (
            <div>
                <label className='commonLabelText' >{label}</label>
                <AdminStarRating
                    name={input.name}
                    change={input.onChange}
                    value={input.value}
                    editing={true}
                    className={s.reviewsFormStar}
                />
                {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
            </div>
        )
    }

    async submitForm(values, dispatch) {
        const { mutate, demoRestriction } = this.props;
        const isRestrict = await demoRestriction({});
        if (isRestrict) return;

        const { data } = await mutate({ variables: values });
        if (data?.writeUserReview) {
            if (data?.writeUserReview?.status === '200') {
                if (values.id) {
                    showToaster({ messageId: 'updateUserReview', toasterType: 'success' })
                    history.push('/siteadmin/user-reviews')
                } else {
                    showToaster({ messageId: 'updateUserReview', toasterType: 'success' })
                    //dispatch(reset('UserReviewsForm'));
                    //history.push('/siteadmin/user-reviews')
                }
            } else if (data?.writeUserReview?.status === '404') {
                showToaster({ messageId: 'listIdNotAvailable', toasterType: 'error' })
            } else {
                showToaster({ messageId: 'adminReviewFailed', toasterType: 'error' })
            }
        }
    }

    render() {
        const { error, handleSubmit, submitting, title, initialValues } = this.props;
        const { formatMessage } = this.props.intl;

        return (
            <div>
                <h1 className='siteAdminHeading'>{formatMessage(messages.managementReviews)}</h1>
                <div className='siteAdminCenterContainer'>
                    <div className={cx('singleBtnFlexEnd', cp.spaceBottom4)}>
                        <Link to={'/siteadmin/user-reviews'} className='goBackLink'>
                            <GoBackArrow />
                            <FormattedMessage  {...messages.goBack} />
                        </Link>
                    </div>
                    <div className='siteAdminCenterContainerBox'>
                        <form onSubmit={handleSubmit(this.submitForm)}>
                            {error && <strong>{formatMessage(error)}</strong>}
                            <div className="oneColumnGrid">
                                <Field name="reviewContent"
                                    component={CommonFormComponent}
                                    inputClass='commonTextAreaField'
                                    componentClass={'textarea'}
                                    labelText={formatMessage(messages.reviewContentLabel)}
                                    placeholder={formatMessage(messages.reviewContentLabel)}
                                    isRequiredInput
                                />

                                <Field name="rating"
                                    component={this.renderStarRating}
                                    label={formatMessage(messages.reviewRating)} />
                            </div>

                            <div className={cx(cp.spaceTop4, 'singleBtnFlexEnd')}>
                                <Button className={cx(cp.btnPrimary)} type="submit" disabled={submitting} >
                                    <FormattedMessage  {...messages.submit} />
                                </Button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }

}

UserReviewsForm = reduxForm({
    form: 'UserReviewsForm', // a unique name for this form
    validate
})(UserReviewsForm);

const mapState = (state) => ({});

const mapDispatch = {
    demoRestriction
};

export default compose(injectIntl,
    connect(mapState, mapDispatch),
    withStyles(cp, s),
    withMutation(WriteUserReviewMutation)
)(UserReviewsForm);